import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import en from './locales/en.json';
import de from './locales/de.json';
import fr from './locales/fr.json';
import it from './locales/it.json';
import es from './locales/es.json';
import salesUi from './locales/salesUi.json';

const withSalesUi = (locale, language) => ({
  translation: { ...locale, salesUi: salesUi[language] }
});

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: withSalesUi(en, 'en'),
      de: withSalesUi(de, 'de'),
      fr: withSalesUi(fr, 'fr'),
      it: withSalesUi(it, 'it'),
      es: withSalesUi(es, 'es')
    },

    fallbackLng: 'en',
    interpolation: {
      escapeValue: false
    },
    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: 'erp_language',
      caches: ['localStorage']
    }
  });

export default i18n;
